/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import { Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
    StyledBannerGridItem,
    StyledBannerText,
    StyledBannerImg,
    StyledBannerSubText,
} from "./styles";
import Computer from "@js/public/images/Computer.png";

interface EducationBannerProps {
    bannerTitle: string;
    bannerSubtext: string;
    hasBannerImage?: boolean;
}

const EducationBanner = ({
    bannerTitle,
    bannerSubtext,
    hasBannerImage = false,
}: EducationBannerProps) => {
    const theme = useTheme();

    return (
        <Grid
            container
            item
            justifyContent="center"
            sx={{
                backgroundColor: theme.palette.primary.main,
                alignItems: "center",
                borderRadius: "15px",
                marginTop: "15px",
            }}
        >
            <Grid
                item
                container
                xl={7}
                lg={7}
                md={7}
                sm={7}
                xs={10}
                flexDirection="column"
                sx={{ paddingLeft: "10px", paddingBottom: "5px" }}
            >
                <StyledBannerGridItem>
                    <StyledBannerText variant="h3">
                        {bannerTitle}
                    </StyledBannerText>
                </StyledBannerGridItem>
                <StyledBannerGridItem>
                    <StyledBannerSubText variant="subtitle1">
                        {bannerSubtext}
                    </StyledBannerSubText>
                </StyledBannerGridItem>
            </Grid>
            <Grid
                justifyContent="center"
                item
                xl={4}
                lg={4}
                md={4}
                sm={4}
                xs={0}
                sx={{ height: "100%", display: "flex", alignItems: "center" }}
            >
                {hasBannerImage ? (
                    <StyledBannerImg src={Computer.src} alt="Web3" />
                ) : null}
            </Grid>
        </Grid>
    );
};

export default EducationBanner;
